(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimo-flip-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mimo-flip-showcase')) {
  customElements.define('mimo-flip-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const option = event.target.closest('[data-colour-id]');
        if (!option || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.querySelectorAll('[data-colour-panel]').forEach(panel => { panel.hidden = panel.dataset.colourPanel !== option.dataset.colourId; });
        this.querySelectorAll('[data-colour-id]').forEach(link => link.setAttribute('aria-current', String(link === option)));
        this.querySelector('[data-colour-name]').textContent = option.dataset.colourTitle;
        this.querySelector('[data-button-colour]').textContent = option.dataset.colourTitle;
        this.querySelector('.mf-selector-price').textContent = option.dataset.colourPrice;
        this.querySelector('[data-colour-shop]').href = option.href;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
